import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { axiosClient } from "../../../common/axios"
import Column from "../../../common/components/Column"
import TextLink from "../../../common/components/TextLink"
import AdminAuthTitle from "../components/AdminAuthTitle"
import AdminLoadingPaper from "../components/AdminLoadingPaper"

export default function AdminForgotPassword() {
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState(null)
  const navigate = useNavigate()

  function handleSubmit(e) {
    e.preventDefault()
    setIsLoading(true)
    axiosClient
      .post("/users/api/password/reset/request/", { email })
      .then(() => navigate("/admin/forgot-password-email-sent/"))
      .catch(({ response }) =>
        setEmailError(response?.data?.email || "Request failed.")
      )
      .finally(() => setIsLoading(false))
  }

  return (
    <AdminLoadingPaper isLoading={isLoading}>
      <AdminAuthTitle
        title="Reset password"
        subtitle="Enter your staff email to receive a password reset link."
      />
      <form onSubmit={handleSubmit} style={{ width: "100%" }}>
        <Column gap={2.5}>
          <TextField
            label="Email Address"
            size="small"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)
              setEmailError(null)
            }}
            error={!!emailError}
            helperText={emailError}
            fullWidth
            required
          />
          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={!email}
            fullWidth
            sx={{ borderRadius: 3 }}
          >
            Send reset email
          </Button>
        </Column>
      </form>
      <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
        <TextLink to="/admin/log-in/" text="Back to login" />
      </Typography>
    </AdminLoadingPaper>
  )
}
